<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import LogoIcon from './LogoIcon.vue'

const { t } = useI18n()

const footerLinks = [
  { key: 'product', href: '#product' },
  { key: 'solutions', href: '#solutions' },
  { key: 'docs', href: '#' },
  { key: 'privacy', href: '#' },
  { key: 'terms', href: '#' }
]
</script>

<template>
  <footer class="footer">
    <div class="container footer__inner">
      <div class="footer__brand">
        <div class="footer__logo">
          <LogoIcon />
          <span>积米 JMTMS</span>
        </div>
        <p class="footer__slogan">{{ t('footer.slogan') }}</p>
      </div>

      <nav class="footer__nav" aria-label="Footer">
        <a
          v-for="link in footerLinks"
          :key="link.key"
          :href="link.href"
        >
          {{ t(`footer.links.${link.key}`) }}
        </a>
      </nav>
    </div>

    <div class="footer__bottom">
      <div class="container footer__bottom-inner">
        <p>{{ t('footer.copyright') }}</p>
        <p class="footer__icp">
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
          >{{ t('footer.icp') }}</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  background: var(--color-dark);
  color: var(--color-bg);
  padding-top: 5rem;
}

.footer__inner {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 3rem;
  padding-bottom: 3rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.footer__logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
  color: var(--color-bg);
}

.footer__logo svg {
  width: 32px;
  height: 32px;
}

.footer__logo span {
  font-family: var(--font-display);
  font-size: 1.375rem;
  font-weight: 700;
}

.footer__slogan {
  max-width: 320px;
  font-size: 0.9375rem;
  color: var(--color-text-tertiary);
  line-height: 1.7;
}

.footer__nav {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
}

.footer__nav a {
  font-size: 0.9375rem;
  font-weight: 500;
  color: var(--color-text-tertiary);
  transition: color var(--duration-fast) var(--ease-out-expo);
}

.footer__nav a:hover {
  color: var(--color-bg);
}

.footer__bottom {
  padding-block: 1.5rem;
}

.footer__bottom-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.footer__bottom p {
  font-size: 0.8125rem;
  color: var(--color-text-tertiary);
}

.footer__icp a {
  color: var(--color-text-tertiary);
  transition: color var(--duration-fast) var(--ease-out-expo);
}

.footer__icp a:hover {
  color: var(--color-bg);
}

@media (max-width: 768px) {
  .footer__inner {
    flex-direction: column;
    gap: 2rem;
  }

  .footer__nav {
    gap: 1.25rem;
  }
}
</style>
